import { createSelector } from '@reduxjs/toolkit';

import {
  getSearcherFromCountry,
  getSearcherStartDate,
  getSearcherAdults,
  getSearcherKidsCount,
  getSearcherKidsAgesText,
} from './searcher';

import { getSelectedFromCity } from './departures';

import {
  convertServerDateToClientDate,
  checkDateFormat,
} from '../../../../utils/dateUtils';
import { getSearchType } from './view';
import { getSearchedNights } from './common';

export interface SearchParamsType {
  from: string;
  nights: number;
  adults: number;
  kids: number;
  start_date: string;
  kids_ages: Array<number> | undefined;
  request_id: string | undefined;
}

/**
 * Возвращает поисковые параметры отеля вида
 * @param {object} state reducer
 * @returns Возвращает поисковые параметры отеля
 */
export const getSearchParamsForUrl = createSelector(
  [
    getSelectedFromCity,
    getSearcherFromCountry,
    getSearcherStartDate,
    getSearchedNights,
    getSearcherAdults,
    getSearcherKidsCount,
    getSearcherKidsAgesText,
    getSearchType,
  ],
  (
    fromCity,
    fromCountry,
    startDate,
    nights,
    adults,
    kids,
    kidsAges,
    searchType,
  ) => {
    const from = `${fromCity.nameEn.trim().replace(/\s/g, '.')}-${fromCountry}`;

    const formattedStartDate = checkDateFormat(startDate)
      ? startDate
      : convertServerDateToClientDate(startDate);

    return {
      from,
      nights,
      adults,
      kids,
      start_date: formattedStartDate,
      search_type: searchType,
      kids_ages: kids ? kidsAges : undefined,
      request_id: undefined,
    };
  },
);
